import { Outlet, Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import UserContext from '../contexts/UserContext.js';
import { useContext } from 'react';

export default function ProtectedRoute()
{
    const userContext = useContext(UserContext);

    if(userContext?.loading)
    {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if(!userContext?.user)
    {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
}
